import Step from "../../components/step/Step";
import { Box, SimpleGrid, Text, useRadioGroup } from "@chakra-ui/react";
import RadioCard from "../../components/radio-card/RadioCard";
import { useNavigate } from "react-router-dom";
import { translation } from "../../utils/translation";

function Step8() {
  let navigate = useNavigate();

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: "q8",
    onChange: () => {
      navigate("../step9", { replace: true });
    },
  });

  const options = [
    {
      id: "a1",
      text: translation("general.step8.option1"),
    },
    {
      id: "a2",
      text: translation("general.step8.option2"),
    },
    {
      id: "a3",
      text: translation("general.step8.option3"),
    },
    {
      id: "a4",
      text: translation("general.step8.option4"),
    },
  ];

  const group = getRootProps();

  return (
    <Step
      heading={translation("general.step8.headline")}
      currentStep={6}
      backLink={"/step7"}
    >
      <SimpleGrid mt={5} spacing={2} columns={1} {...group}>
        {options.map((value) => {
          const radio = getRadioProps({ value: value.id });
          return (
            <RadioCard key={value.id} {...radio}>
              <Box display={"flex"} alignItems={"center"}>
                <Text fontSize={"lg"} fontWeight={"bold"}>
                  {value.text}
                </Text>
              </Box>
            </RadioCard>
          );
        })}
      </SimpleGrid>
    </Step>
  );
}

export default Step8;
